export function registerMyWorkQueue(Alpine) {
    document.addEventListener("alpine:init", () => {
        Alpine.data("myWorkQueue", () => ({
            init() {
                this.$wire.on("my-work-advanced", ({ selectedItemId }) => {
                    this.$nextTick(() => {
                        window.setTimeout(
                            () => this.focusAdvancedItem(selectedItemId),
                            250,
                        );
                    });
                });
            },

            focusAdvancedItem(selectedItemId) {
                const target = selectedItemId
                    ? this.$root.querySelector(
                          `[data-work-item-id="${CSS.escape(selectedItemId)}"]`,
                      )
                    : this.$root.querySelector("[data-my-work-empty]");

                target?.focus({ preventScroll: true });
            },
        }));
    });
}
